import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { installChunkReloadGuard } from './lib/chunkReloadGuard';
import { initSentry } from './lib/sentry';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import './index.css';

initSentry();
installChunkReloadGuard();

// diag: on-screen console for real-device diagnosis (?diag=1) — remove after diagnosis
if (typeof window !== 'undefined') {
  const diagOn = new URLSearchParams(window.location.search).get('diag') === '1';
  if (diagOn) {
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/eruda';
    script.onload = () => {
      if (window.eruda) window.eruda.init();
    };
    document.body.appendChild(script);
  }
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <ErrorBoundary>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </HelmetProvider>
  </ErrorBoundary>
);

